export const getFileNameFromAbsolutePath = (absolutePath) => absolutePath.split('/').pop();
